import { render, staticRenderFns } from "./LessonCard.vue?vue&type=template&id=55817b92&"
import script from "./LessonCard.vue?vue&type=script&lang=js&"
export * from "./LessonCard.vue?vue&type=script&lang=js&"
import style0 from "./LessonCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports